import { render, staticRenderFns } from "./mainFormManualProject.vue?vue&type=template&id=07c20fce&"
import script from "./mainFormManualProject.vue?vue&type=script&lang=js&"
export * from "./mainFormManualProject.vue?vue&type=script&lang=js&"
import style0 from "./mainFormManualProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports